import { Component, Input } from '@angular/core';
import { WeissmanModalService } from '../../Compliance/WeissmanModalService';
import {
    AssessmentTaxesDetailsModalComponent,
    AssessmentTaxesDetailsModalParams,
} from './assessment-taxes-details-modal.component';

@Component({
    selector: 'assessment-taxes-details-icon',
    template: ` <i class="fa fa-th" style="cursor: pointer;" (click)="showModal()"></i> `,
    imports: [],
})
export class AssessmentTaxesDetailsIconComponent {
    constructor(private readonly _weissmanModalService: WeissmanModalService) {}

    @Input() siteId?: number;
    @Input() parcelId?: number;
    @Input() selectableYears?: number[];

    showModal(): void {
        const params: AssessmentTaxesDetailsModalParams = {
            siteId: this.siteId,
            parcelId: this.parcelId,
            selectableYears: this.selectableYears,
        };

        this._weissmanModalService.showAsync(AssessmentTaxesDetailsModalComponent, params, 'modal-lg');
    }
}
